var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRegion = function SvgRegion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "region_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "region_svg__st0",
    d: "M32 44.5c-3.6-4.4-12.2-16.1-12.2-21.7 0-6.8 5.5-12.3 12.2-12.3S44.2 16 44.2 22.8c0 5.6-8.6 17.3-12.2 21.7M32 7c-8.6 0-15.7 7.1-15.7 15.8 0 8.1 11.8 22.6 13.2 24.3.6.7 1.5 1.2 2.4 1.2.9 0 1.8-.4 2.4-1.2 1.4-1.6 13.2-16.2 13.2-24.3C47.7 14.1 40.6 7 32 7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "region_svg__st0",
    d: "M32 26.3c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5m0-10.5c-3.8 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.2-7-7-7M62.1 57H1.9c-.7 0-1.3-.4-1.6-.9-.3-.6-.4-1.3-.1-1.9l8-15.2c.5-.9 1.7-1.3 2.6-.8.9.5 1.3 1.7.8 2.6L5.1 53.1h53.6l-7.2-12.3c-.5-.9-.2-2.1.7-2.6.9-.5 2.1-.2 2.6.7l8.9 15.2c.3.6.4 1.3 0 1.9-.3.6-.9 1-1.6 1z"
  })));
};
export default SvgRegion;